import { createEffect } from 'effector'
import { getStoriesInfo } from './api'
import { postUploadStories } from './api'
export const uploadStoriesFx = createEffect(async (token: string, image: FormData) => {
  const data = await postUploadStories(token, image)
  return data
})

export const getStoriesInfoFx = createEffect(async (token: string) => {
  const data = await getStoriesInfo(token)
  return data
})
